<script setup lang="ts">
import WrRightArrowIcon from "../atoms/icons/WrRightArrowIcon.vue";

const emit = defineEmits(["backToForm"]);
const onBackClick = () => {
  emit("backToForm");
};

const props = defineProps({
  layoutChange: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="p-px bg-[image:var(--border-form)] !rounded-xl">
    <div
      class="grow lg:px-[3rem] px-[1rem] rounded-xl h-full relative bg-[image:var(--bg-form)]"
      :class="
        props.layoutChange
          ? 'bg-white dark:bg-inherit pt-5 pb-5 '
          : 'bg-[image:var(--bg-form)] py-20'
      "
    >
      <div class="flex flex-col items-center text-center">
        <NuxtImg
          src="/images/namaste.svg"
          alt="Thank You"
          height="113"
          width="121"
          loading="lazy"
          class="h-auto max-w-full"
        />
        <h2 class="max-sm:text-2xl max-md:text-3xl text-4xl font-bold mt-4">
          <WrGradientText :text="'Namaste!'" />
        </h2>
        <p>
          You may receive an introduction email from
          <strong
            ><a
              href="mailto:we@webreinvent.com"
              class="text-[#5f4ca4] dark:text-[var(--primary)] dark:underline cursor-pointer"
              >we@webreinvent.com</a
            ></strong
          >

          or a call from
          <strong
            ><a
              href="tel:+91 858 886 4948"
              class="text-[#5f4ca4] dark:text-[var(--primary)] dark:underline cursor-pointer"
              >+91 858 886 4948</a
            ></strong
          >
        </p>
      </div>
      <div
        class="flex flex-col items-center justify-cente gap-2"
        :class="props.layoutChange ? 'mt-10' : 'mt-20'"
      >
        <p class="text-2xl max-sm:text-xl flex items-center gap-2">
          What's Next?
          <WrRightArrowIcon class="w-[1.5rem] h-[1.5rem] fill-current" />
        </p>
        <h3 class="text-4xl max-md:text-3xl max-sm:text-2xl font-bold">
          <a
            class="text-[#5f4ca4] dark:text-[var(--primary)] dark:underline cursor-pointer"
            href="https://calendly.com/webreinvent/consult"
            target="_blank"
            >Schedule a meeting</a
          >
        </h3>
        <div class="mt-5">
          <WrButton class="w-full" @click="onBackClick">Go Back</WrButton>
        </div>
      </div>
      <div
        class="border-l-4 border-[#7957d5] dark:border-[#fff] dark:bg-transparent dark:text-white text-[#552fbc] rounded px-6 py-5 mt-4 bg-[#f3f1f9]"
      >
        If you're a talented software professional and believe in working with
        us, feel free to
        <a
          href="https://webreinvent.ohoapps.com/hrm#/jobs"
          target="_blank"
          class="text-[#5f4ca4] dark:text-[var(--primary)] dark:underline cursor-pointer"
          ><strong>schedule an interview </strong>
        </a>
        or call us at:
        <strong
          ><a
            href="tel:+91 794 344 4427"
            class="text-[#5f4ca4] dark:text-[var(--primary)] dark:underline cursor-pointer"
            >+91 794 344 4427
          </a></strong
        >
      </div>
    </div>
  </div>
</template>
